<div class="d-flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
    <div class="d-flex flex-column align-items-center justify-content-center main-div">
      
      <div>
        <p class="error">
          404
        </p> 
      </div>
      <div>
        <p class="not-found-msg">
          PAGE NOT FOUND
        </p> 
      </div>
      <div>
        <p>
          The resource requested can't be found on this server.
        </p> 
      </div>
      <div>
        <button class="btn btn-primary" routerLink = "/home/dashboard/mainDashboard">Go to home page</button>
      </div>
    </div>
</div>